var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { IconBaseSvg } from "../icon-base";
var SkipNextIcon = function (props) { return (React.createElement(IconBaseSvg, __assign({}, props, { viewBox: "0 0 24 24" }),
    React.createElement("g", { id: "Icon/ic_skip_next", stroke: "none", strokeWidth: "1", fill: "inherit", fillRule: "evenodd" },
        React.createElement("path", { id: "ic_skip_next_1", fill: "inherit", d: "M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z" }),
        React.createElement("path", { id: "ic_skip_next_2", d: "M0 0h24v24H0z", fill: "none" })))); };
export default SkipNextIcon;
//# sourceMappingURL=SkipNextIcon.js.map